// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9591eee2","35":"5f285eaf","40":"0438e328","78":"bc4925c4","444":"5c97de76","453":"a2d80f35","550":"ad297d6c","590":"faafcc0a","720":"ff03ae2c","776":"a274f4df","784":"df715473","857":"b69728fc","929":"54e81b01"}[chunkId] + ".chunk.js";
};